import React, { useState, useEffect, Fragment } from 'react';

import './count.css'

export default function Count(props) {

    const [countAccred, setCountAccred] = useState(0)  
    const [countNotAccred, setCountNotAccred] = useState(0)    
  

    useEffect(() => {

        fetch('https://playattitude.fr/event/mbm2020/count', {
            method: 'GET'
        })
        .then(res => res.json())
            .then(res => {
                console.log(res, res.accred.people_in)
                setCountAccred(res.accred.people_in)
                setCountNotAccred(res.not_accred.people_in)
            })
    }, [])


    return (
        <div className="center">
            <h2>Personnes accrédités:</h2>
            <h2>{countAccred}</h2>
            <br/>
            <h2>Personnes non accrédités:</h2>
            <h2>{countNotAccred}</h2>
        </div>
    );
}